import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { routes } from "modules/common/routes";

const defaultState: RedirectState = { from: routes.main.path };

/**
 * Обёртка вокруг содержимого маршрута, доступного только не вошедшим (страница входа).
 * Вошедшего возвращает туда, откуда его развернул `ProtectedRoute`.
 */
export const AnonymousRoute = ({ loggedIn, children }: AnonymousRouteProps) => {
    const location = useLocation();

    if (loggedIn) {
        const state = (location.state as RedirectState | null) || defaultState;

        return <Navigate to={state.from} replace={true} />;
    }

    return <>{children}</>;
};

export interface RedirectState {
    from: string;
}

export interface LoggedInProps {
    loggedIn: boolean;
}

interface AnonymousRouteProps extends LoggedInProps {
    children?: React.ReactNode;
}
